import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Instagram, Facebook, MessageCircle, Clock } from "lucide-react";
import { SITE, waHref } from "@/data/site";

const linksHizli = [
  { to: "/", label: "Anasayfa" },
  { to: "/hakkimizda", label: "Hakkımızda" },
  { to: "/hizmetlerimiz", label: "Hizmetlerimiz" },
  { to: "/urunlerimiz", label: "Ürünlerimiz" },
  { to: "/blog", label: "Blog" },
  { to: "/iletisim", label: "İletişim" },
];

const linksHizmet = [
  { to: "/lazer-epilasyon", label: "Lazer Epilasyon" },
  { to: "/hydrafacial-cilt-bakimi", label: "Hydrafacial" },
  { to: "/podoloji", label: "Medikal Ayak Bakımı" },
  { to: "/kalici-makyaj", label: "Kalıcı Makyaj" },
  { to: "/ipek-kirpik", label: "İpek Kirpik" },
  { to: "/manikur-pedikur", label: "Manikür - Pedikür" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0E2B4F] text-white pt-20 pb-8 border-t border-[#0E2B4F]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <div className="font-display text-3xl mb-6 font-semibold">
            Medi<span className="text-[#10B981]">Este</span>
          </div>
          <p className="text-white/70 text-sm leading-relaxed max-w-xs">
            Ankara Bağlıca'da güzellik, cilt bakımı ve medikal ayak sağlığı alanında uzman kadromuzla hizmet veriyoruz.
          </p>
          <div className="flex gap-3 mt-6">
            <a href={SITE.socials.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="h-10 w-10 rounded-full border border-white/20 flex items-center justify-center text-white/80 hover:text-white hover:bg-white/10 hover:border-white/40 transition"><Instagram size={16} /></a>
            <a href={SITE.socials.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="h-10 w-10 rounded-full border border-white/20 flex items-center justify-center text-white/80 hover:text-white hover:bg-white/10 hover:border-white/40 transition"><Facebook size={16} /></a>
            <a href={waHref()} target="_blank" rel="noreferrer" aria-label="WhatsApp" className="h-10 w-10 rounded-full bg-[#10B981] flex items-center justify-center text-white hover:bg-[#059669] transition"><MessageCircle size={16} /></a>
          </div>
        </div>

        <div>
          <h4 className="font-display text-lg mb-5 text-[#10B981] font-semibold">Hızlı Linkler</h4>
          <ul className="space-y-2.5">
            {linksHizli.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm text-white/70 hover:text-white transition-colors">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg mb-5 text-[#10B981] font-semibold">Hizmetlerimiz</h4>
          <ul className="space-y-2.5">
            {linksHizmet.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm text-white/70 hover:text-white transition-colors">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg mb-5 text-[#10B981] font-semibold">İletişim</h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex items-start gap-3"><MapPin size={16} className="text-[#10B981] mt-1 shrink-0" /><span>{SITE.address}</span></li>
            <li className="flex items-center gap-3"><Phone size={16} className="text-[#10B981]" /><a href={`tel:${SITE.phoneRaw}`} className="hover:text-white">{SITE.phone}</a></li>
            <li className="flex items-center gap-3"><Mail size={16} className="text-[#10B981]" /><a href={`mailto:${SITE.email}`} className="hover:text-white">{SITE.email}</a></li>
            <li className="flex items-center gap-3"><Clock size={16} className="text-[#10B981]" /><span>{SITE.hours}</span></li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-xs text-white/50">© {new Date().getFullYear()} MediEste Estetik & Güzellik. Tüm hakları saklıdır.</p>
        <p className="text-xs text-white/50">Ankara Bağlıca • Etimesgut</p>
      </div>
    </footer>
  );
}
